module.exports = __webpack_public_path__ + "images/emoji/minidisc.c719877217d032cb0e56.png";